import { Common, ApiBind } from './common.model';

export class PlatformKey extends Common {
  @ApiBind({ column: 'platform_id' })
  platformId: number;

  @ApiBind({ column: 'encrypt_key' })
  encryptKey: string;

  @ApiBind({ column: 'sample' })
  sample: string;
}
